<template>
  <div>
    <div
      class="modal fade"
      id="modal-block-add-widget-form-manager"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-block-add-widget"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-add-service modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="block block-themed block-transparent mb-0">
            <div class="block-header bg-primary-dark">
              <h3 class="block-title">Add Widget</h3>
              <div class="block-options">
                <button
                  type="button"
                  class="btn-block-option"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content">
              <div class="row">
                <div
                  class="col-md-3 mb-3"
                  v-for="(item, key) in allWidgets.data"
                  :key="key"
                >
                  <div class="utility">
                    <div for="product-8">
                      <button
                        data-toggle="modal"
                        data-target="#widgetAddModal"
                        class="btn btn-warning float-right m-1"
                        style="right: 0; position: absolute"
                        @click="handleEditWidgets(item)"
                      >
                        <i class="far fa-edit"></i>
                      </button>

                      <p class="mt-3">
                        <i class="fab fa-wpforms fa-2x mt-3"></i>
                      </p>
                      <p>
                        <span>{{ item.name }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 pb-3 pr-4">
                  <div
                    class="btn-group btn-group-lg float-right"
                    role="group"
                    aria-label="Large Horizontal Outline Primary"
                  >
                    <a
                      @click="getWidgets(currentPage - 1)"
                      v-if="currentPage !== 1"
                      href="javascript:void(0)"
                    >
                      <button type="button" class="btn btn-outline-info">
                        <i class="fa fa-arrow-left"></i>
                      </button>
                    </a>
                    <a href="javascript:void(0)">
                      <button
                        type="button"
                        class="btn btn-outline-info ml-3 mr-3"
                        disabled
                      >
                        {{ currentPage }}
                      </button></a
                    >
                    <a
                      @click="getWidgets(currentPage + 1)"
                      v-if="currentPage !== lastPage"
                      href="javascript:void(0)"
                    >
                      <button type="button" class="btn btn-outline-info">
                        <i class="fa fa-arrow-right"></i>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="widgetAddModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Widgets ({{ selectedWidget }})
            </h5>
            <button
              type="button"
              class="btn-close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <h4>Delete from forms</h4>
                <div :key="formName" v-for="formName in deleteFromForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
                <br />
              </div>
              <div class="col-md-6">
                <h4>Add to forms</h4>
                <div :key="formName" v-for="formName in addToForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import $ from "jquery"
export default {
  name: "AddWidgetFormManager",
  props: ["formsData", "selectedForms"],
  computed: mapState({
    allWidgets: state => state.widgets.AllWidgets
  }),
  data: () => {
    return {
      deleteFromForms: [],
      addToForms: [],
      selectedWidget: "",
      currentPage: 0,
      lastPage: 0,
      widgetValidation: [
        {
          id: 19,
          lead: 3,
          contract: 1
        }
      ]
    };
  },
  mounted() {
    this.getAllWidgets().then(response => {
      this.currentPage = response.data.meta.current_page;
      this.lastPage = response.data.meta.last_page;
    });
  },
  methods: {
    ...mapActions({
      getAllWidgets: "widgets/getAllWidgets",
      getWidgetsByPage: "widgets/getWidgetsByPage"
    }),
    handleEditWidgets(item) {
      this.selectedWidget = item.name;
      this.deleteFromForms = [];
      this.addToForms = [];
      this.deleteFromForms = Object.values(this.formsData.widgets).filter(
        x => x.title === item.name
      )[0]
        ? Object.values(this.formsData.widgets).filter(
            x => x.title === item.name
          )[0].forms
        : [];
      let temp = [];
      this.selectedForms.map(form => {
        temp.push(form.name);
      });
      let temp2 = [];
      temp.map(a => {
        if (!this.deleteFromForms.includes(a)) {
          temp2.push(a);
        }
      });
      this.addToForms = temp2;
    },

    getWidgets: function(page) {
      this.getWidgetsByPage(page).then(response => {
        this.currentPage = response.data.meta.current_page;
        this.lastPage = response.data.meta.last_page;
      });
    },
    addWidget: function(item) {
      let lastItem = this.form.data.fields[this.form.data.fields.length - 1];
      let newId =
        lastItem.length > 0
          ? lastItem[lastItem.length - 1].id + 1
          : this.form.data.fields.length * 30;
      this.$store.state.forms.formStateData.data.fields.push({
        id: newId,
        action:
          item.id == 19 ? "familysituation" : item.id === 3 ? "postcode" : "",
        group: "widget",
        type: item.id == 19 ? "familySituation" : "html",
        title: item.id == 19 ? "Family Situation" : item.name,
        description: {},
        css: item.id == 19 ? "" : "custom css",
        widgetCardId: item.id,
        html: item.id == 19 ? "" : item.contents
      });
    },
    deleteWidget: function(id) {
      this.$store.state.forms.formStateData.data.fields.map((data, index) => {
        if (data.widgetCardId && data.widgetCardId === id) {
          this.$store.state.forms.formStateData.data.fields.splice(index, 1);
        }
      });
    },
    findItem: function(id) {
      return this.$store.state.forms.formStateData.data.fields.find(
        item => item.widgetCardId === id
      );
    },
    IsDisable(id) {
      if (this.isLead) {
        return this.widgetValidation.find(a => a.id == id)
          ? [1, 2].includes(this.widgetValidation.find(a => a.id == id).lead)
            ? true
            : false
          : false;
      } else {
        return this.widgetValidation.find(a => a.id == id)
          ? [1, 2].includes(
              this.widgetValidation.find(a => a.id == id).contract
            )
            ? true
            : false
          : false;
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
</style>
